import { FaClock, FaEnvelope, FaGlobe, FaComments } from "react-icons/fa";


const contacts = [
  {
    id: 2,
    icon: <FaEnvelope />,
    title: "mail us",
    content: ["asdesigns632@gmail.com"],
  },
{
  id: 4,
  icon: <FaComments />,
  title: "Start a Chat",
  content: [
    "Ask any questions related to our products",
    "Get answers fast via email support"
  ],
},
{
        id: 4,
        icon: <FaClock />,
        title: "response time",
        content: [
            "We usually reply within 24 hours",
            "Monday – Friday"
        ],
    },
    
];

export default contacts;


